<template>
  <main class="mx-auto pt-16">
    <div class="container mx-auto">
      <CommonBackToButton
        text-to="About Us"
        url="/about"
        class="pt-5 md:pt-12"
      />
    </div>

    <div class="container mx-auto mb-8 mt-6">
      <UtilsSkeletonLoading v-if="isLoading" class="w-full h-10 md:h-16" />
      <h1
        v-else
        class="text-[22px] leading-normal sm:text-[40px] sm:leading-[50px] font-medium mb-4 text-bw-900"
      >
        Embracing Innovation and Thriving in Every Digital Stage
      </h1>
    </div>

    <template v-if="isLoading">
      <div
        v-for="i in 3"
        :key="i"
        class="flex flex-col md:flex-row gap-x-10 gap-y-4 mx-auto"
      >
        <UtilsSkeletonLoading class="w-1/5 lg:w-[13%] h-20 md:h-48" />
        <UtilsSkeletonLoading class="w-2/3 md:w-2/5 lg:w-1/2 h-24 md:h-48" />
        <div class="w-full md:w-2/5 flex flex-col gap-2">
          <UtilsSkeletonLoading class="w-4/5 md:w-1/3 h-8 md:h-11" />
          <UtilsSkeletonLoading class="w-1/3 md:w-3/4 h-8 md:h-10" />
          <UtilsSkeletonLoading class="w-1/5 md:w-3/4 h-8 md:h-14" />
          <UtilsSkeletonLoading class="w-2/5 h-8 md:h-10" />
        </div>
      </div>
    </template>
    <section
      v-else
      class="relative content"
      v-html="approachData.attributes?.content"
    ></section>
    <!-- <section class="relative content">
      <div
        class="flex odd flex-col md:min-h-[360px] approach-wrapper py-6 md:pt-16 md:pb-20 md:flex-row relative"
      >
        <div class="container mx-auto flex flex-col md:flex-row">
          <div
            class="number text-[80px] md:text-[200px] leading-[1.25] md:leading-normal text-[#D2D2D2] font-medium mr-6 ml-0 md:absolute md:-left-8 md:top-0 opacity-25"
          >
            <span class="">01</span>
          </div>
          <div class="title-desc md:ml-52 mb-6 md:my-auto z-10">
            <h2
              class="section-heading mb-5"
            >
              Discover
            </h2>
            <p class="text-sm leading-[22px] md:text-base text-bw-800 w-3/4">
              We embark on a journey of exploration, research, and data
              gathering to uncover valuable insights that drive significant
              change and growth for our clients.
            </p>
          </div>
          <div class="approach pl-4 md:pl-9 border-l border-[#E8E8E8]">
            <h3 class="text-base md:text-lg text-bw-900 mb-3 md:mb-4 font-medium">
              How We Do
            </h3>
            <ul class="list-disc ml-4">
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Analyze quantitative and qualitative market research based on
                industry needs and digital talent development
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Analyze and compare existing systems
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Analyze user experience from the target market
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="flex even flex-col md:min-h-[360px] approach-wrapper py-6 md:pt-16 md:pb-20 md:flex-row relative"
      >
        <div class="container mx-auto flex flex-col md:flex-row">
          <div
            class="number even text-[80px] md:text-[200px] leading-[1.25] md:leading-normal text-[#D2D2D2] font-medium mr-6 ml-0 md:absolute md:-left-8 md:top-0 opacity-25"
          >
            02
          </div>
          <div class="title-desc md:ml-52 mb-6 md:my-auto z-10">
            <h2
              class="section-heading mb-5"
            >
              Define
            </h2>
            <p class="text-sm leading-[22px] md:text-base text-bw-800 w-3/4">
              We help our clients create their digital strategies to addressing
              the right problems that leads to targeted solutions.
            </p>
          </div>
          <div class="approach pl-4 md:pl-9 border-l border-[#E8E8E8]">
            <h3 class="text-base md:text-lg text-bw-900 mb-3 md:mb-4 font-medium">
              How We Do
            </h3>
            <ul class="list-disc ml-4">
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Build brand strategy concept, including visualization and brand
                voice
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Create the concept for digital campaigns
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Create strategies for content, SEO, and digital advertising
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Create mockup design
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="flex odd flex-col md:min-h-[360px] approach-wrapper py-6 md:pt-16 md:pb-20 md:flex-row relative"
      >
        <div class="container mx-auto flex flex-col md:flex-row">
          <div
            class="number text-[80px] md:text-[200px] leading-[1.25] md:leading-normal text-[#D2D2D2] font-medium mr-6 ml-0 md:absolute md:-left-8 md:top-0 opacity-25"
          >
            03
          </div>
          <div class="title-desc md:ml-52 mb-6 md:my-auto z-10">
            <h2
              class="section-heading mb-5"
            >
              Deliver
            </h2>
            <p class="text-sm leading-[22px] md:text-base text-bw-800 w-3/4">
              We specialize in providing comprehensive solutions for branding,
              product, and marketing, ensuring that your ideas are transformed
              into tangible results.
            </p>
          </div>
          <div class="approach pl-4 md:pl-9 border-l border-[#E8E8E8]">
            <h3 class="text-base md:text-lg text-bw-900 mb-3 md:mb-4 font-medium">
              How We Do
            </h3>
            <ul class="list-disc ml-4">
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Develop frontend prorotype in form of static website and mobile
                application template
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Develop backend (API)
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Setup and configure the production environment based on the
                physical infrastructure design
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Create creative content
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Optimize digital marketing (organic &amp; inorganic)
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="flex even flex-col md:min-h-[360px] approach-wrapper py-6 md:pt-16 md:pb-20 md:flex-row relative"
      >
        <div class="container mx-auto flex flex-col md:flex-row">
          <div
            class="number even text-[80px] md:text-[200px] leading-[1.25] md:leading-normal text-[#D2D2D2] font-medium mr-6 ml-0 md:absolute md:-left-8 md:top-0 opacity-25"
          >
            04
          </div>
          <div class="title-desc md:ml-52 mb-6 md:my-auto z-10">
            <h2
              class="section-heading mb-5"
            >
              Determine
            </h2>
            <p class="text-sm leading-[22px] md:text-base text-bw-800 w-3/4">
              We provide the analysis to determine the success of your business
              and drive continuous improvement by measuring the performance of
              implemented strategy and solutions.
            </p>
          </div>
          <div class="approach pl-4 md:pl-9 border-l border-[#E8E8E8]">
            <h3 class="text-base md:text-lg text-bw-900 mb-3 md:mb-4 font-medium">
              How We Do
            </h3>
            <ul class="list-disc ml-4">
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Monitor and evaluate technical performance
              </li>
              <li
                class="text-bw-900 text-sm leading-[22px] md:text-base mb-2 md:mb-3"
              >
                Monitor and evaluate digital marketing implementation
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section> -->
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo
const mainBanner = global.mainBanner
const isLoading = ref(true)

const route = useRoute()
const SEOMeta = ref({})

const approachData = ref([])

const [approach, seo] = await Promise.all([
  useSuitmediaApiData(`/api/approach`, {
    query: {
      'fields[0]': 'id',
      'fields[1]': 'content'
    }
  }),
  useSuitmediaApiData(`/api/seo-metas`, {
    query: {
      'filters[url]': route.path,
      populate: 'seo.image'
    }
  })
])

isLoading.value = approach.pending.value

if (approach.error.value) {
  throw createError({
    statusCode: 404,
    message: `Approach does not exist`
  })
}

SEOMeta.value = seo.data.value.data[0]
approachData.value = approach.data.value.data

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  url: SEOMeta?.value?.attributes?.url || 'suitmedia.com',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})
useSeoMeta({
  title: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: SEOMeta?.value?.attributes?.seo?.open_graph_type,
  twitterTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  twitterImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})
</script>

<style lang="scss" scoped>
// .number {
//   width: 33%;
// }
:deep(.content) {
  .approach-wrapper {
    overflow: hidden;
  }

  .title-desc,
  .approach {
    @media screen and (min-width: 768px) {
      width: 50%;
    }
  }

  .approach {
    margin: auto 0;
  }
}
:deep(.even) {
  background: #f9f9f9;
}

:deep(.even) {
  &:first-child {
    .number {
      &::before {
        content: none;
      }
    }
  }
  &:last-child {
    .number {
      &::after {
        content: none;
      }
    }
  }
}
:deep(.odd) {
  &:first-child {
    .number {
      &::before {
        content: none;
      }
    }
  }
  &:last-child {
    .number {
      &::after {
        content: none;
      }
    }
  }
}

:deep(.number) {
  // position: relative;
  @media screen and (min-width: 768px) {
    width: calc(100% - 800px);
    z-index: 1;
    height: 100%;
  }
}
:deep(.number::before) {
  @media screen and (min-width: 768px) {
    content: '';
    top: 0;
    bottom: 84%;
    right: calc(100% - 188px);
    z-index: -1;

    position: absolute;
    width: 1px;

    border: none;
    margin-left: 8px;

    background: linear-gradient(to bottom, transparent 50%, #223049 50%);
    background-size:
      27px 22px,
      100% 2px;
  }

  @media screen and (min-width: 1024px) {
    bottom: 80%;
  }
}
:deep(.number::after) {
  @media screen and (min-width: 768px) {
    content: '';
    position: absolute;
    width: 1px;
    top: 47%;
    bottom: 0;
    right: calc(100% - 188px);
    z-index: -1;

    border: none;
    height: calc(100% - 190px);
    margin-left: 8px;
    border-width: 2px;

    background: linear-gradient(to bottom, transparent 50%, #223049 50%);
    background-size:
      27px 22px,
      100% 2px;
  }

  @media screen and (min-width: 1024px) {
    top: 60%;
  }
}
</style>
